import React, {useEffect} from "react";
import {useMenuManager} from "../../../layout/hooks/use-menu-manager";
import {useArticleForm} from "../hooks/use-article-form.hook";
import {Case, Switch} from "@common/components/switch-case";
import {ArticleFormStep} from "../contexts/article-form-context";
import ArticleFormContent from "../components/article-form/article-form-content";
import ArticleFormSpecialists from "../components/article-form/article-form-specialists";
import ArticleFormRelatedArticles from "../components/article-form/article-form-related-articles";
import ArticleFormAuthor from "../components/article-form/article-form-author";
import ArticleFormExercises from "../components/article-form/article-form-exercises";
import {State, ViewStates} from "@common/components/view-states";
import {ViewState} from "@common/models/enums/viev-state.enum";

interface ArticleFormViewProps {
    articleId?: string;
}

const ArticleFormView: React.FC<ArticleFormViewProps> = ({articleId}) => {
    const {setArticleEditMenu, setMainMenu} = useMenuManager();
    const {currentStep, isEditMode, formData, loading, resetForm, clearForm, loadArticleById, loadDraftArticle} = useArticleForm();

    useEffect(() => {
        setArticleEditMenu();
        return () => {
            setMainMenu();
            if (articleId) {
                clearForm();
            } else {
                resetForm();
            }
        }
    }, [articleId]);

    useEffect(() => {
        if (articleId) {
            void loadArticleById(articleId);
        } else {
            loadDraftArticle();
        }
    }, []);

    return (
        <div>
            <ViewStates
                loading={isEditMode ? loading : false}
                error={null}
                data={isEditMode ? formData : {fake: true}}
            >
                <State state={ViewState.LOADING}/>
                <State state={ViewState.FETCHED}>
                    <Switch value={currentStep}>
                        <Case case={ArticleFormStep.CONTENT}>
                            <ArticleFormContent/>
                        </Case>
                        <Case case={ArticleFormStep.EXERCISES}>
                            <ArticleFormExercises/>
                        </Case>
                        <Case case={ArticleFormStep.AUTHOR}>
                            <ArticleFormAuthor/>
                        </Case>
                        <Case case={ArticleFormStep.RELATED}>
                            <ArticleFormRelatedArticles/>
                        </Case>
                        <Case case={ArticleFormStep.SPECIALIST}>
                            <ArticleFormSpecialists/>
                        </Case>
                    </Switch>
                </State>
                <State state={ViewState.EMPTY}/>
                <State state={ViewState.ERROR}/>
            </ViewStates>
        </div>
    )
}

export default ArticleFormView
